import { render, staticRenderFns } from "./RiglessInfo.vue?vue&type=template&id=e84b7dbe"
import script from "./RiglessInfo.vue?vue&type=script&lang=ts"
export * from "./RiglessInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports